import { render, staticRenderFns } from "./EquityScheme.vue?vue&type=template&id=a28cb84e"
import script from "./EquityScheme.vue?vue&type=script&lang=js"
export * from "./EquityScheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports